export class VLine {
	//top
	public t: number;
	//x
	public x: number;
	//bottom
	public b: number;
	//extra
	public e: number;
	constructor(line : any) {
		if (line) {
			this.t = line.t;
			this.x = line.x;
			this.b = line.b;
			this.e = line.e ? line.e : 0;
		}
	}
}